import GoogleButton from 'components/common/Buttons/GoogleButton';
import Button from 'components/common/Buttons/index';
import HeroCrumbs from 'components/Sections/Hero/HeroCrumbs';
import { useAnimationWithWithoutScroll } from 'hooks/useAnimation';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentFeatureIsLoading, selectCurrentFeaturesTags } from 'store/slices/FeaturesSlice';

const HeroComponent = ({ title, desc, button, hasCrumbs = true }) => {
    const container = useRef();
    const isLoading = useSelector(selectCurrentFeatureIsLoading);
    const featuresTags = useSelector(selectCurrentFeaturesTags)


    useAnimationWithWithoutScroll({
        item: '.hero-body',
        container,
        dependencies: [isLoading],
        isLoading: isLoading
    })
    useAnimationWithWithoutScroll({
        item: '.hero-button',
        container,
        dependencies: [isLoading],
        isLoading: isLoading
    })

    return (
        <div ref={container} className={`hero-container ${hasCrumbs ? "hero-container--with-crumbs" : ""}`}>
            {hasCrumbs && <HeroCrumbs page={title} />}
            <div className='hero-body'>
                <h1 className='hero-body__title'>{title}</h1>
                <div className='body1 hero-body__desc'>{desc}</div>
            </div>
            <div className='hero-body-buttons'>

                <Button text={button} forPopup={true} />
                {
                    featuresTags.start_with_google_button && <GoogleButton />
                }


            </div>
        </div>
    );
}

export default HeroComponent;